<vs-connected-table-page
  #page
  endpoint="/api/policies"
  [columns]="columns$ | async"
  [queryParams]="queryParams$ | async"
  [page]="{
    title: 'Policies',
    icon: 'file-shield-02',
    showDivider: true,
    description: 'This is an overview of all policies configured for your organization.'
  }"
  (rowClicked)="navigateTo($event.id)"
>
  <div slot="header-end" class="flex max-w-full sm:max-w-min gap-2">
    <ng-container *ngIf="canCreate$ | async">
      <button
        *ngIf="((page.datasource?.meta$ | async)?.totalItems ?? 0) > 0"
        vs-button
        theme="primary"
        size="md"
        class="flex-grow"
        (click)="createPolicyDialog.open()"
      >
        <vs-icon name="plus"></vs-icon>
        New Policy
      </button>
    </ng-container>

    <button
      *ngIf="((page.datasource?.meta$ | async)?.totalItems ?? 0) > 0"
      vs-button
      size="md"
      class="px-3 py-2"
      appearance="outline"
      cdkMenuPosition="before"
      [vsMenuTriggerFor]="downloadMenu"
    >
      <vs-icon name="download-01"></vs-icon>
    </button>

    <ng-template #downloadMenu>
      <vs-menu class="mt-2">
        <button vs-menu-item (click)="downloadPolicies()">CSV file (.csv)</button>
      </vs-menu>
    </ng-template>
  </div>

  <ng-container *ngIf="(canCreate$ | async) === true" slot="empty">
    <button vs-button theme="primary" size="md" class="flex-grow" (click)="createPolicyDialog.open()">
      <vs-icon name="plus"></vs-icon>
      New Policy
    </button>
  </ng-container>

  <div *vsLet="refreshOnPolicyChange$ | async" class="mb-4 flex justify-between gap-4">
    <vs-select
      vsInput
      class="min-w-[20%] max-w-[25%]"
      [config]="{ placeholder: 'All statuses', allowDeselect: true }"
      [value]="filters?.status ?? null"
      (valueChanges)="onStatusChange($event)"
    >
      <li *ngFor="let status of statuses" vs-select-option [value]="status">{{ status | titlecase }}</li>
    </vs-select>

    <vs-input-container class="max-w-[25%]">
      <vs-icon name="search-lg" slot="start"></vs-icon>
      <input
        #searchInput
        vsInput
        [value]="filters?.search ?? ''"
        (input)="refreshTable({ search: searchInput.value })"
        placeholder="Search"
      />
    </vs-input-container>
  </div>
</vs-connected-table-page>

<!-- Dialogs -->
<ws-policy-dialog #createPolicyDialog></ws-policy-dialog>

<ws-policy-dialog #editPolicyDialog [policy]="selectedPolicy" [editing]="editPolicyType"></ws-policy-dialog>

<ws-publish-policy-dialog #publishPolicyDialog [policy]="selectedPolicy"></ws-publish-policy-dialog>

<ws-archive-policy-dialog #archivePolicyDialog [policy]="selectedPolicy"></ws-archive-policy-dialog>

<ws-restore-policy-dialog #restorePolicyDialog [policy]="selectedPolicy"></ws-restore-policy-dialog>

<!-- Templates -->
<ng-template #buttonRef let-policyNumber="subtitle">
  <button
    vs-button
    size="sm"
    appearance="clear"
    class="px-2 py-2 m-[-10px]"
    [cdkCopyToClipboard]="policyNumber"
    (click)="copyPolicyNumber(policyNumber)"
  >
    <vs-icon name="clipboard"></vs-icon>Click to copy
  </button>
</ng-template>

<ng-template #draftTooltipRef>
  <p class="text-gray-700 text-xs font-semibold">This policy is a draft.</p>
  <p class="text-gray-500 text-xs font-medium">
    <span class="text-primary-700">Publish</span> this policy to activate it.
  </p>
</ng-template>

<ng-template #archiveTooltipRef>
  <p class="text-gray-700 text-xs font-semibold">This policy has been archived.</p>
  <p class="text-gray-500 text-xs font-medium">
    <span class="text-primary-700">Restore</span> this policy to create a new version it.
  </p>
</ng-template>

<ng-template #runoffTooltipRef>
  <p class="text-gray-700 text-xs font-semibold">This policy still has active warranties.</p>
  <p class="text-gray-500 text-xs font-medium">
    It will be archived once all associated warranties have expired. <span class="text-primary-700">Restore</span> this
    policy to create a new version it.
  </p>
</ng-template>
